import React from 'react'

import { Dialog, useDialogState } from '../../../../components/dialog'
import { Spinner } from '../../../../components/spinner'
import { useAsyncModule } from '../../../../services/async-modules-utils'
import { saveToPortfolioAsyncModule } from '../../../save-to-portfolio/async-modules'
import { QuoteContext } from '../../QuoteContext'
import { NavigationLink } from './QuoteLinkComponent'

export function SaveToPortfolioLink() {
  const { ticker } = React.useContext(QuoteContext)
  const dialog = useDialogState()
  const isVisible = dialog.useState('open')

  const [saveToPortfolioModule] = useAsyncModule({
    ...saveToPortfolioAsyncModule,
    shouldLoadModule: isVisible,
  })
  const SaveToPortfolio = saveToPortfolioModule?.SaveToPortfolio

  return (
    <>
      <NavigationLink
        getLink={() => `/save_to_portfolio.ashx?t=${ticker}`}
        onClick={(e) => {
          if (!FinvizSettings.email.length) return
          window.gtag?.('event', 'click', { event_category: 'save-to-portfolio' })
          if (e.ctrlKey || e.metaKey) return
          e.preventDefault() // needed to prevent opening parent link
          dialog.show()
        }}
      >
        Add to Portfolio
      </NavigationLink>
      <Dialog state={dialog} aria-label="Add to Portfolio" className="w-110">
        {SaveToPortfolio ? (
          <SaveToPortfolio ticker={ticker} />
        ) : (
          <div className="flex h-56 items-center justify-center">
            <Spinner />
          </div>
        )}
      </Dialog>
    </>
  )
}
